import {
  APP_SETTING_DELETE_LAYOUT_BEGIN,
  APP_SETTING_DELETE_LAYOUT_SUCCESS,
  APP_SETTING_DELETE_LAYOUT_FAILURE,
  APP_SETTING_DELETE_LAYOUT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteLayout(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_LAYOUT_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/layout/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_DELETE_LAYOUT_SUCCESS,
              data: args.uuid,
            });
            toast.success('Deleted Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_DELETE_LAYOUT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_LAYOUT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteLayoutError() {
  return {
    type: APP_SETTING_DELETE_LAYOUT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_LAYOUT_BEGIN:
      return {
        ...state,
        deleteLayoutPending: true,
        deleteLayoutError: null,
      };

    case APP_SETTING_DELETE_LAYOUT_SUCCESS:
      return {
        ...state,
        deleteLayoutPending: false,
        deleteLayoutError: null,
        layouts: state.layouts.filter((e) => e.uuid !== action.data),
      };

    case APP_SETTING_DELETE_LAYOUT_FAILURE:
      return {
        ...state,
        deleteLayoutPending: false,
        deleteLayoutError: action.data.error,
      };

    case APP_SETTING_DELETE_LAYOUT_DISMISS_ERROR:
      return {
        ...state,
        deleteLayoutError: null,
      };

    default:
      return state;
  }
}
